module.exports = __webpack_public_path__ + "static/media/button-video-frame.d66d54b2.svg";